<template>
    <li>
        <button
            @click.prevent="exportTray(tray.name)"
            :disabled="!tray.pin_count || isDownloading"
            class="disabled:opacity-50 disabled:pointer-events-none bg-v2-white border border-v2-white flex font-medium gap-3 items-center leading-none max-w-full p-3 relative rounded text-v2-gray-20 text-left text-xs w-full hover:border-v2-gray-70 dark:bg-v2-gray-65 dark:border-v2-gray-10 dark:text-v2-gray-130 hover:dark:border-v2-gray-90 hover:dark:text-v2-white"
        >
            <LoadingCircle v-if="isDownloading" />
            <BaseSvg
                v-else
                name="ExportFile"
                aria-hidden="true"
                class="fill-v2-gray-70 shrink-0 size-4 dark:fill-v2-gray-90"
            />
            Export tray
        </button>
    </li>
</template>

<script setup>
import {usePinsDrawer} from "@/Composables";
import {LoadingCircle} from "@/Components";

const props = defineProps(['tray']);

const { exportTray, isDownloading } = usePinsDrawer();
</script>
